import './Email.css';
import { IoIosMail } from 'react-icons/io';

function Email() {
    return (
        <div id="email-icon">
            <IoIosMail />
        </div>
    );
}

export default Email;